import {
    get_progetti,
    get_progetto,
    create_progetto,
    update_progetto,
    delete_progetto,
} from "@/api/api.progetti.js";

const progetti = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
        SET_CORRENTE: (state, progetto) => { state.corrente = progetto; },
    },

    actions: {
        carica({ commit }, search) {
            return new Promise((resolve, reject) => {
                get_progetti(search).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_progetto(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_progetto(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_progetto(id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_progetto(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default progetti;
